import { BaseButtonTheme, styles, variants } from '../BaseButtonStyles.css';
import { multiVariantStyles } from './BaseButtonVariants.css';
import './BaseButtonBaseTheme.css';

const BaseButtonRedwoodTheme: BaseButtonTheme = {
  multiVariantStyles,
  variants,
  styles
};

export { BaseButtonRedwoodTheme };
